// eslint-disable-next-line no-unused-vars
import React, { useEffect } from "react";
import { Input, notification, Table, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { getArtworksTransactionsCount } from "../lib/api";
import {
  GoogleReCaptchaProvider,
  GoogleReCaptcha,
} from "react-google-recaptcha-v3";
import axios from "axios";
import { useCallback } from "react";

const Home = () => {
  const [searchValue, setSearchValue] = React.useState("");
  const [artworks, setArtworks] = React.useState([]);
  const [recaptchaValid, setRecaptchaValid] = React.useState(false);
  const columns = [
    {
      title: "Artwork Title",
      dataIndex: "title",
    },
    {
      title: "Transactions Count",
      dataIndex: "transactionsCount",
    },
    {
      title: "Latest transaction at",
      dataIndex: "timestamp",
    },
  ];
  const Navigate = useNavigate();

  useEffect(() => {
    const fetchPaintings = async () => {
      const data = await getArtworksTransactionsCount();

      setArtworks(data);
    };

    fetchPaintings();
  }, []);

  const handleVerify = useCallback( async (token) => {
    const res = await axios.post(
      `${import.meta.env.VITE_API_BACKOFFICE_URL}/verify/captcha`,
      {
        captchaValue: token,
      }
    );

    const { data } = res || {};

    if (data.success) {
      setRecaptchaValid(true);
    } else {
      setRecaptchaValid(false);
    }
  }, []);
  return (
    <>
      <Input.Search
        size="large"
        allowClear
        value={searchValue}
        enterButton="Search"
        className="w-full"
        placeholder="Enter a Transaction Hash"
        onChange={(e) => setSearchValue(e.target.value?.replace(/\s+/g, ""))}
        onSearch={(e) => {
          if (recaptchaValid) {
            const trimmedValue = e.replace(/\s+/g, "");
            Navigate(`/tx/${trimmedValue}`);
          } else {
            notification.error({
              message: "Please verify that you are not a robot",
            });
          }
        }}
      />
      <Table
        columns={columns}
        size="large"
        dataSource={artworks}
        title={() => <Typography.Title level={4}>Paintings</Typography.Title>}
      />
      <GoogleReCaptchaProvider reCaptchaKey={import.meta.env.VITE_API_SITE_KEY}>
        <GoogleReCaptcha onVerify={handleVerify} />
      </GoogleReCaptchaProvider>
    </>
  );
};

export default Home;
